import { useSpotlight } from '../../hooks/useSpotlight';

export default function Spotlight() {
  const ref = useSpotlight();
  return <div className="spotlight" ref={ref} />;
}
